import { Component, Input, OnInit } from '@angular/core';
import IReplaceLandUseStatistic = ZoningAPI.IReplaceLandUseStatistic;

@Component({
    standalone: false,
    selector: 'app-replace-land-use-id-statistic-section',
    templateUrl: './replace-land-use-id-statistic-section.component.html',
    styleUrls: [
        './replace-land-use-id-statistic-section.component.scss',
        '../../../../../../shared/styles/mdl-table.scss'
    ]
})
export class ReplaceLandUseIdStatisticSectionComponent implements OnInit {
    @Input()
    replaceLandUseStatistic: IReplaceLandUseStatistic;

    constructor() {}

    ngOnInit(): void {}
}
